import { logger } from '@icc/shared/helpers';
import { Injectable, Inject, Optional } from '@angular/core';
import { EventBusService } from '@icc/shared/event-bus.service';
import { IConfigurationsService, CONFIGURATIONS_SERVICE, ConfigurationType } from '@icc/configurator/types';
import { PriceBaseService } from './price-base.service';

/**
 * Usługa liczenia ceny
 *
 * @export
 * @class PriceService
 */
@Injectable()
export class PriceService {
    syncRequests: number = 0;
    syncingPrice = false;

    /**
     * Creates an instance of PriceService.
     *
     * @param {ng.ui.bootstrap.IModalService} $uibModal $uibModal
     * @param {any} ConfigurationsService ConfigurationsService
     * @param {PriceBaseService} priceBaseService PriceBaseService
     *
     * @memberOf PriceService
     */
    constructor(
        @Inject(CONFIGURATIONS_SERVICE) private configurationsService: IConfigurationsService,
        private priceBaseService: PriceBaseService,
        private eventBusService: EventBusService
    ) {
        this.eventBusService.subscribe(
            [
                'changedBalcony',
                'changedFillings',
                'changedSashes',
                'changedStep',
                'putAlignmentInField',
                'putExtensionOnSide',
                'removedAlignmentInField',
                'removedAlignment',
                'removedExtensionFromSide',
                'setConstructionColor',
                'setExtensionProfile',
                'setFrameProfile',
                'setGlazingInSash',
                'setGlazingBeadInSash',
                'setMullionProfile',
                'setProfileSet',
                'setSashProfile',
                'setSealColor',
                'setSiliconeColor',
                'setShape',
                'setSystem',
                'setWarmEdge',
                'setLowThreshold',
                'unsetLowThreshold',
                'insertMuntins',
                'removeMuntins',
                'updateMuntins',
                'setMuntinColor',
                'changedAlushell',
                'changedOptions',
                'montageOptionsChanged',
                'changedDrive',
                'changedDoorHardware',
                'configurationChanged',
                'setFillingColor',
                'setMuntinColor',
                'setDoorPortal',
                'changedConfigurator',
                'changedFinWidths',
                'changeCurrency',
                'setLippingColor',
                'grayPolystyreneChanged',
                'setPanelGlazing',
                'setPanelTrim',
                'changeSlat'
            ],
            data => {
                try {
                    if (data.activeConfiguration) {
                        this.count();
                    }
                } catch (err) {
                    logger.error(err);
                }
            }
        );
    }

    async syncPrice(fromTimeout = false) {
        if (this.syncRequests > 0 || !this.configurationsService.conf.Current.PriceValid) {
            this.syncRequests = 0;

            this.priceBaseService.setPrice(this.configurationsService.conf.Current);
            if (fromTimeout) {
                this.eventBusService.post({
                    key: 'updatedPrice',
                    value: null
                });
            }
        }

        if (this.syncingPrice) {
            setTimeout(() => {
                this.syncPrice(true);
            }, 100);
        }
    }

    /**
     * Przelicza cenę
     *
     * @param {*} config Konfiguracja
     * @param {*} [offer]  Oferta
     * @returns {number} Wyliczona cena
     *
     * @memberOf PriceService
     */
    count(config?, offer?, additionalPriceModifier?) {
        if (config) {
            return this.priceBaseService.setPrice(config, offer, null, additionalPriceModifier);
        } else {
            if (this.configurationsService.conf.Current.PriceValid) {
                this.configurationsService.conf.Current.PriceValid = false;
            }
            this.syncRequests++;
            return NaN;
        }
    }

    static equalPrices(a: number, b: number) {
        return Math.abs(a - b) < 0.01;
    }
}
